"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listSharedDocumentCandidatesApiResponseSchema = exports.previewSharedDocumentNotificationApiResponseSchema = exports.previewSharedDocumentRecipientsApiResponseSchema = exports.publishSharedDocumentApiResponseSchema = exports.listSharedDocumentsApiResponseSchema = exports.listSharedDocumentsItemApiResponseSchema = exports.sharedDocumentTargetSummarySchema = exports.SHARED_DOCUMENT_LIST_NAMED_TARGETS = exports.sharedDocumentScopeTypeSchema = exports.sharedDocumentAudienceSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const shared_document_1 = require("./shared-document");
exports.sharedDocumentAudienceSchema = zod_1.z.enum(shared_document_1.sharedDocumentAudiences);
exports.sharedDocumentScopeTypeSchema = zod_1.z.enum(shared_document_1.sharedDocumentScopeTypes);
/**
 * How many targets a list row names; beyond, it only counts them
 * ("3 cabinets"), so the list loads no more names than this.
 */
exports.SHARED_DOCUMENT_LIST_NAMED_TARGETS = 2;
/**
 * A target as the administration list names it; `closed` flags a deleted
 * site or a closed office, which no longer reaches anyone.
 */
exports.sharedDocumentTargetSummarySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
    closed: zod_1.z.boolean(),
});
exports.listSharedDocumentsItemApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('shared-documents'),
    attributes: zod_1.z.object({
        title: zod_1.z.string(),
        description: zod_1.z.string().nullable(),
        fileName: zod_1.z.string(),
        /** Size in bytes. */
        fileSize: zod_1.z.number().int(),
        audience: exports.sharedDocumentAudienceSchema,
        scopeType: exports.sharedDocumentScopeTypeSchema,
        /** The first targets by name, at most `SHARED_DOCUMENT_LIST_NAMED_TARGETS`. */
        targets: zod_1.z.array(exports.sharedDocumentTargetSummarySchema),
        /** Every target of the scope. */
        targetCount: zod_1.z.number().int(),
        mandatoryRead: zod_1.z.boolean(),
        notifyByEmail: zod_1.z.boolean(),
        /** Current recipients only. */
        recipientCount: zod_1.z.number().int(),
        /** Current recipients who opened it, or confirmed a mandatory reading. */
        readCount: zod_1.z.number().int(),
        publishedAt: zod_1.z.coerce.date(),
    }),
});
exports.listSharedDocumentsApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.listSharedDocumentsItemApiResponseSchema).extend({
    /** Documents matching the filters, across every page. */
    total: zod_1.z.number().int(),
});
exports.publishSharedDocumentApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('shared-documents'),
        attributes: zod_1.z.object({ title: zod_1.z.string() }),
    }),
    meta: zod_1.z.object({
        /** E-mails queued for sending; 0 when notification is off. */
        queuedEmailCount: zod_1.z.number().int(),
    }),
});
exports.previewSharedDocumentRecipientsApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        recipientCount: zod_1.z.number().int(),
        /** The first recipients by last name, at most six. */
        firstRecipients: zod_1.z.array(zod_1.z.object({
            userId: zod_1.z.string().uuid(),
            firstName: zod_1.z.string(),
            lastName: zod_1.z.string(),
        })),
    }),
});
exports.previewSharedDocumentNotificationApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        subject: zod_1.z.string(),
        /** The e-mail exactly as sent, rendered to HTML. */
        html: zod_1.z.string(),
    }),
});
exports.listSharedDocumentCandidatesApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        sites: zod_1.z.array(zod_1.z.object({
            id: zod_1.z.string().uuid(),
            name: zod_1.z.string(),
            openOfficeCount: zod_1.z.number().int(),
        })),
        offices: zod_1.z.array(zod_1.z.object({
            id: zod_1.z.string().uuid(),
            name: zod_1.z.string(),
            siteId: zod_1.z.string().uuid(),
            siteName: zod_1.z.string(),
        })),
        people: zod_1.z.array(zod_1.z.object({
            userId: zod_1.z.string().uuid(),
            firstName: zod_1.z.string(),
            lastName: zod_1.z.string(),
            email: zod_1.z.string(),
        })),
    }),
});
